import React, { useState } from 'react';
import { Card, Table, Typography } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { useCurrency } from '@/contexts/CurrencyContext';
import salesConversionReportsService from '@/services/salesConversionReports.service';
import { defaultSalesReportFilters, SalesReportFilterBar } from './SalesReportFilterBar';

const { Title } = Typography;

const SalesRepPerformancePage: React.FC = () => {
  const { formatCurrency } = useCurrency();
  const [filters, setFilters] = useState(defaultSalesReportFilters());
  const { data, isLoading } = useQuery({
    queryKey: ['sales-rep-performance', filters],
    queryFn: () => salesConversionReportsService.salespersonPerformance(filters),
  });

  return (
    <div style={{ padding: 24 }}>
      <Title level={3}>Salesperson performance</Title>
      <SalesReportFilterBar value={filters} onChange={setFilters} />
      <Card>
        <Table
          loading={isLoading}
          size="small"
          rowKey={(r) => String(r.owner_id || r.salesperson)}
          dataSource={data?.rows || []}
          scroll={{ x: true }}
          columns={[
            { title: 'Salesperson', dataIndex: 'salesperson', fixed: 'left', width: 180 },
            { title: 'Leads', dataIndex: 'leads', align: 'right' },
            { title: 'Opps', dataIndex: 'opportunities', align: 'right' },
            { title: 'Quotes', dataIndex: 'quotations', align: 'right' },
            { title: 'SOs', dataIndex: 'sales_orders', align: 'right' },
            {
              title: 'Booked',
              dataIndex: 'booked_value',
              align: 'right',
              render: (v) => formatCurrency(Number(v || 0)),
            },
            { title: 'Invoices', dataIndex: 'invoices', align: 'right' },
            {
              title: 'Invoiced',
              dataIndex: 'invoiced_value',
              align: 'right',
              render: (v) => formatCurrency(Number(v || 0)),
            },
            {
              title: 'Prior booked',
              dataIndex: 'prior_booked_value',
              align: 'right',
              render: (v) => (v == null ? '—' : formatCurrency(Number(v))),
            },
          ]}
          pagination={{ pageSize: 25 }}
        />
      </Card>
    </div>
  );
};

export default SalesRepPerformancePage;
